import { SxStyle } from '@/utils/reactTypes';
import { gql } from '@apollo/client';
import { Tooltip } from '@mui/material';
import moment from 'moment';

import { TagChip } from '../tags/TagChip';

export const PatientStatusTagFragment = gql`
    fragment PatientStatusTag on Patient {
        isDeceased
        deceasedAt
        isActive
    }
`;
interface PatientStatusTagProps {
    isDeceased: boolean;
    deceasedAt: Date | null;
    isActive: boolean;
    sx?: SxStyle;
}

export const PatientStatusTag = ({
    isDeceased,
    deceasedAt,
    isActive,
    sx,
}: PatientStatusTagProps) => {
    if (isDeceased) {
        const dateLabel = deceasedAt ? moment(deceasedAt).format('MMM D, YYYY') : '';
        return (
            <Tooltip title={`Deceased ${dateLabel}`.trim()}>
                <span>
                    <TagChip label='Deceased' size='small' sx={sx} />
                </span>
            </Tooltip>
        );
    }
    if (!isActive) {
        return <TagChip label='Inactive' size='small' sx={sx} />;
    }
    return null;
};
